import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper, FontIcon, Toggle } from 'material-ui';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import { css, StyleSheet } from 'aphrodite';
import RateNameTextSettingsList from './rate-name-text-settings-list-DUMB';
import { merge, update, propEq, __, findIndex, eqProps, call, compose, concat, filter, map, omit } from 'ramda';
const styles = StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
});
const updateAnItemAndPushUp = (newItem, list) => call(compose(
  newList => concat(newList.filter(propEq('checked', true)), newList.filter(propEq('checked', false))),
  update(__, newItem, list),
  findIndex(eqProps('text', newItem))
), list);
// Rate Name is Stay_Type in the doc limited 20, the first one in tourplan, also shown in the sub left menu
// Rate Text is Rate_Text in the doc limited 60
const IntegrationSettings = ({
  rateNameSetting,
  rateTextSetting,
  rateNameUseCombination,
  rateTextUseCombination,
  rateNamePopoverOpen,
  rateNameAnchorEl,
  rateNamePopoverContent,
  rateTextPopoverOpen,
  rateTextAnchorEl,
  rateTextPopoverContent,
  updateSettings,
  enableRateNameButton,
  enableRateTextButton,
  savingSettings,
  saveSettings,
  triggerSnackBarMessage,
}) => {
  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <FontIcon className="tc-icon-bulb" color="#ffc800" style={{ fontSize: '24px', top: '-8px' }} />
        <div style={{ display: 'inline-block', width: '90%', marginLeft: '2%' }}>
          You can configure the Rate Name and Rate Text fields that will be exported into Tourplan with the list of options below.
        </div>
      </div>
      <Paper style={{ marginTop: '24px' }}>
        <div className={css(styles.header)}>Rate Name Settings (20 character limit in Tourplan)</div>
        <br />
        <RateNameTextSettingsList
          limit={19}
          popoverContent={rateNamePopoverContent}
          popoverOpen={rateNamePopoverOpen}
          anchorEl={rateNameAnchorEl}
          closePopover={() => updateSettings({ rateNamePopoverOpen: false, rateNameAnchorEl: undefined, rateNamePopoverContent: {} })}
          openPopover={(anchorEl, popoverContent) => updateSettings({ rateNamePopoverOpen: true, rateNameAnchorEl: anchorEl, rateNamePopoverContent: popoverContent })}
          useCombination={rateNameUseCombination}
          arrayOfData={rateNameSetting}
          dragEnds={newData => updateSettings({ rateNameSetting: newData, enableRateNameButton: true })}
          onToggle={toggeled => updateSettings({ rateNameUseCombination: toggeled, enableRateNameButton: true })}
          checkAnItem={(item) => updateSettings({ rateNameSetting: updateAnItemAndPushUp(merge(item, { checked: !item.checked }), rateNameSetting), enableRateNameButton: true })}
        />
        <RaisedButton
          label={enableRateNameButton ? 'Save' : 'Saved'}
          secondary
          loader={savingSettings}
          disabled={!enableRateNameButton}
          style={{ margin: '12px 80%', width: '130px' }}
          onTouchTap={() => {
            saveSettings(
              {
                rateNameSetting,
                rateNameUseCombination,
              },
              { enableRateNameButton: false }
            )
              .catch(() => {
                triggerSnackBarMessage('Unable to save rate name settings');
                updateSettings({ enableRateNameButton: true });
              });
          }}
        />
      </Paper>
      <Paper style={{ marginTop: '24px' }}>
        <div className={css(styles.header)}>Rate Text Settings (60 character limit in Tourplan)</div>
        <br />
        <RateNameTextSettingsList
          limit={59}
          popoverContent={rateTextPopoverContent}
          popoverOpen={rateTextPopoverOpen}
          anchorEl={rateTextAnchorEl}
          closePopover={() => updateSettings({ rateTextPopoverOpen: false, rateTextAnchorEl: undefined, rateTextPopoverContent: {} })}
          openPopover={(anchorEl, popoverContent) => updateSettings({ rateTextPopoverOpen: true, rateTextAnchorEl: anchorEl, rateTextPopoverContent: popoverContent })}
          useCombination={rateTextUseCombination}
          arrayOfData={rateTextSetting}
          dragEnds={newData => updateSettings({ rateTextSetting: newData, enableRateTextButton: true })}
          onToggle={toggeled => updateSettings({ rateTextUseCombination: toggeled, enableRateTextButton: true })}
          checkAnItem={(item) => updateSettings({ rateTextSetting: updateAnItemAndPushUp(merge(item, { checked: !item.checked }), rateTextSetting), enableRateTextButton: true })}
        />
        <RaisedButton
          label={enableRateTextButton ? 'Save' : 'Saved'}
          secondary
          loader={savingSettings}
          disabled={!enableRateTextButton}
          style={{ margin: '12px 80%', width: '130px' }}
          onTouchTap={() => {
            saveSettings(
              {
                rateTextSetting,
                rateTextUseCombination,
              },
              { enableRateTextButton: false }
            )
            .catch(() => {
              triggerSnackBarMessage('Unable to save rate text settings');
              updateSettings({ enableRateTextButton: true });
            });
          }}
        />
      </Paper>
    </div>
  );
};

const mapPropsToState = ({ integration }) => ({
  rateNameSetting: integration.getIn(['settings', 'rateNameSetting']).toJS(),
  rateTextSetting: integration.getIn(['settings', 'rateTextSetting']).toJS(),
  rateNameUseCombination: integration.getIn(['settings', 'rateNameUseCombination']),
  rateTextUseCombination: integration.getIn(['settings', 'rateTextUseCombination']),
  rateNamePopoverOpen: integration.getIn(['settings', 'rateNamePopoverOpen']),
  rateNameAnchorEl: integration.getIn(['settings', 'rateNameAnchorEl']),
  rateNamePopoverContent: integration.getIn(['settings', 'rateNamePopoverContent']).toJS(),
  rateTextPopoverOpen: integration.getIn(['settings', 'rateTextPopoverOpen']),
  rateTextAnchorEl: integration.getIn(['settings', 'rateTextAnchorEl']),
  rateTextPopoverContent: integration.getIn(['settings', 'rateTextPopoverContent']).toJS(),
  savingSettings: integration.getIn(['settings', 'savingSettings']),
  enableRateNameButton: integration.getIn(['settings', 'enableRateNameButton']),
  enableRateTextButton: integration.getIn(['settings', 'enableRateTextButton']),
});

export default connect(mapPropsToState)(IntegrationSettings);



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/rate-name-text-settings.jsx